import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class BedTypeService {
  static getBedType(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getbedtype}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getbedtype}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addBedType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addbedtype}`;
    return axiosInstance
        .post(api,item)
        
}

static editBedType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editbedtype}`;
    return axiosInstance
        .put(api,item)
        
}

static deleteBedType(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletebedtype}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletebedtype}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default BedTypeService;